<template>
  <SemkanAuth />
</template>
<script>
import SemkanAuth from '@/assets/icons/semkan-auth.svg?inline'
export default {
  name: 'AuthLogoDefault',
  components: {
    SemkanAuth,
  },
}
</script>
